import {
    ChangeDetectionStrategy,
    Component,
    Input,
    OnChanges,
    QueryList,
    SimpleChanges,
    TemplateRef,
    ViewChild,
    ViewChildren,
    numberAttribute
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
    MatLegacyCheckboxChange as MatCheckboxChange,
    MatLegacyCheckboxModule
} from '@angular/material/legacy-checkbox';
import { FilterBase } from 'src/app/shared/grid/filter-base';
import { GridFilterPopupComponent } from 'src/app/shared/grid/filters/base-filter-popup.component';
import { GridOptionListFilterComponent } from 'src/app/shared/grid/filters/grid-option-list-filter.component';
import { isEmpty } from 'src/app/shared/utilities/obj-utilities';
import { OptionModel } from './option.model';

@Component({
    selector: 'grid-option-list-filter-popup',
    template: ` <grid-filter-popup
        (onResetClick)="onResetClick()"
        (onFilterClick)="onFilterClick()"
        [isFilterActive]="isFilterActive"
        (onClose)="onPopupClose()"
        [width]="width">
        @if (showAllOption) {
            <div>
                <mat-checkbox
                    (change)="selectAllClick($event)"
                    [(ngModel)]="selectAll"
                    [(indeterminate)]="selectAllIndeterminate"
                    labelPosition="after"
                    color="primary">
                    Select All
                </mat-checkbox>
                <hr />
            </div>
        }
        <div
            class="list-container"
            [style.height.px]="height"
            [style.overflow-y]="height > 0 ? 'auto' : null">
            <grid-option-list-filter
                [field]="field"
                [title]="title"
                [options]="options"
                [showOptionSearch]="showOptionSearch"
                [filter]="filter"
                [filterService]="filterService"
                [optionTemplate]="optionTemplate"
                (filterValueChanged)="filterValueChange()"
                [singleSelection]="singleSelection"
                [submitOnChange]="false"
                [convertFilterFormat]="convertFilterFormat">
            </grid-option-list-filter>
        </div>
    </grid-filter-popup>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [GridFilterPopupComponent, MatLegacyCheckboxModule, FormsModule, GridOptionListFilterComponent]
})
export class GridOptionListFilterPopupComponent extends FilterBase implements OnChanges {
    @Input({ transform: numberAttribute }) width = 240;
    @Input() height: number;
    @Input() options: any[];
    @Input() showAllOption = true;
    @Input() optionTemplate: TemplateRef<any>;
    @Input() singleSelection?: boolean = false;
    @Input() convertFilterFormat?: boolean = false;
    @Input() showOptionSearch?: boolean = false;
    @Input() title?: string;

    @ViewChildren(FilterBase) filters: QueryList<FilterBase>;
    @ViewChild(GridOptionListFilterComponent, { static: true }) optionListFilter: GridOptionListFilterComponent;

    selectedOptions: OptionModel[];
    isFilterActive = false;
    selectAllIndeterminate = false;
    selectAll = false;

    filterValueChange() {
        this.selectedOptions = this.getLatestFilterValue();
        this.updateSelectAllStatus();
        this.isFilterActive =
            !isEmpty(this.selectedOptions) && this.selectedOptions.length > 0 && !isEmpty(this.selectedOptions[0]);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['filter']) {
            this.filterValueChange();
        }
    }

    updateSelectAllStatus() {
        if (!this.selectedOptions || this.selectedOptions.length === 0 || !this.options || this.options.length === 0) {
            this.selectAll = false;
            this.selectAllIndeterminate = false;
        } else if (this.selectedOptions.length === this.options.length) {
            this.selectAll = true;
            this.selectAllIndeterminate = false;
        } else {
            this.selectAllIndeterminate = true;
        }
    }

    selectAllClick($event: MatCheckboxChange) {
        this.selectedOptions = $event.checked ? this.options.map((x) => x.id) : [];
        this.optionListFilter.updateSelectedOptions(this.selectedOptions);
    }

    onPopupClose(): void {
        if (this.filters.toArray().some((x) => x.isChanged)) {
            this.submitFilter();
        }
    }

    onResetClick(): void {
        this.trimFilterByField(this.filter, this.field);
        this.submitFilter();
        this.filterValueChange();
    }

    onFilterClick(): void {
        this.submitFilter();
    }

    submitFilter() {
        this.filters.toArray().forEach((x) => (x.isChanged = false));
        super.submitFilter();
    }
}
